import { useEffect } from 'react';

/**
 * Notify to the iFrame manager that the container wants to occupy
 * the full viewport so the iFrame can be resized. (Useful for modals)
 *
 * Test with:
 * window.addEventListener('container-enter-full-screen', (event) => console.log(event));
 */
export function notifyFullViewportMode() {
  const event = document.createEvent('Event');
  event.initEvent('container-enter-full-screen', true, true);
  window.dispatchEvent(event);
}

/**
 * Notify to the iFrame manager that the container wants to return to
 * it's natural size so the iFrame can be resized. (e.g. when closing a modal).
 *
 * Test with:
 * window.addEventListener('container-exit-full-screen', (event) => console.log(event));
 */
export function notifyExitFullViewportMode() {
  const event = document.createEvent('Event');
  event.initEvent('container-exit-full-screen', true, true);
  window.dispatchEvent(event);
}

export function useFullViewport(isFullViewport: boolean) {
  useEffect(() => {
    if (isFullViewport) {
      notifyFullViewportMode();
    }
    return () => {
      if (isFullViewport) {
        notifyExitFullViewportMode();
      }
    };
  }, [isFullViewport]);
}
